import { get } from 'lodash/get'
import { handleError } from 'helper/rest'
import { clientPublic } from 'helper/axios'

export const getDataListCheckList = async ({ params, token }) => {
  try {
    return await clientPublic
      .get(
        `checklist/group?project_id=${params.project_id}&sprintflow_id=${params.sprintflow_id}&limit=20`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const checkListUpdateDone = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`checklist/done`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if (response.status === 400) {
          return response
        } else {
          handleError(response)
        }
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
export const checkboxTaskDone = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`checklist/task/${params.id}/done`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
// upload document
export const uploadDocumentapiPost = async ({ params, token }) => {
  try {
    return await clientPublic
      .post('sprintflow/task/image', params, {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
// get Itemdocument
export const getItemDocument = async ({ params, token }) => {
  try {
    return await clientPublic
      .get(`itemdocument?project_id=${params.project_id}&kind=${params.kind}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
export const getListFileByTaskCheckList = async ({ params, token }) => {
  try {
    return await clientPublic
      .get(
        `itemdocument?project_id=${params.project_id}&sprintflow_id=${params.sprintflow_id}&task_id=${params.task_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
//delete ItemDocument
export const deleteItemDocument = async ({ params, token }) => {
  try {
    return await clientPublic
      .delete(
        `itemdocument/${params.id}?project_id=${params.project_id}&kind=${params.kind}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

//post save location

export const locationPOST = async ({ params, token }) => {
  try {
    return await clientPublic

      .post(`sprintflow/task/location/${params.task_id}`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
